var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerElementSpecialize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 17.5V4.07895H16.7C17.195 4.07895 17.6188 4.25417 17.9713 4.60461C18.3238 4.95504 18.5 5.37632 18.5 5.86842V15.7105C18.5 16.2026 18.3238 16.6239 17.9713 16.9743C17.6188 17.3248 17.195 17.5 16.7 17.5H14.9ZM7.7 4.07895H11.3V2.28947H7.7V4.07895ZM5.9 17.5V2.28947C5.9 1.79737 6.07625 1.3761 6.42875 1.02566C6.78125 0.675219 7.205 0.5 7.7 0.5H11.3C11.795 0.5 12.2188 0.675219 12.5713 1.02566C12.9238 1.3761 13.1 1.79737 13.1 2.28947V17.5H5.9ZM2.3 17.5C1.805 17.5 1.38125 17.3248 1.02875 16.9743C0.67625 16.6239 0.5 16.2026 0.5 15.7105V5.86842C0.5 5.37632 0.67625 4.95504 1.02875 4.60461C1.38125 4.25417 1.805 4.07895 2.3 4.07895H4.1V17.5H2.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerElementSpecialize);
export default __webpack_public_path__ + "static/media/marker_Element_specialize.64cb044ebc2c266b99b87f2979b4d566.svg";
export { ForwardRef as ReactComponent };